import repository from '@/utils/repository';

export default {
    searchFil030Info: (data) => {
        return repository.post('/move/postCommonFil030Info', {
            ...data
        });
    }
};
